{
  "loading": "Indlæser...",
  "loadingMore": "Indlæser flere..."
}
